import toast from '@kk/toast';

export const errHandler = (err, isFinally = true) => {
    if (!err.noToast) {
        toast.show(err.friendlyMessage || err.message || '数据错误，请稍后重试！');
    }
    if (process.env.NODE_ENV !== 'development') {
        Sentry.captureException(err);
    }
    if (!isFinally) {
        throw err;
    }
};
